// import React from "react";
// import axios from "axios";
// import { useState, useEffect } from "react";
// import "./Users.css";
// import "../ECommerce/ECommerce.css";
// import "../Page.css";
// import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
// import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
// import editIcon from "../../Assets/Images/edit.png";
// import deleteIcon from "../../Assets/Images/delete-black.png";
// import eyeIcon from "../../Assets/Images/eye-black.png";
// import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
// import DataTable from "react-data-table-component";
// import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
// import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
// import BottomToust from "../../Components/BottomToust/BottomToust";
// import { PiImage } from "react-icons/pi";
// import { IoImageOutline } from "react-icons/io5";
// import { Url } from "../../Services/Api";
// import { Tooltip } from 'antd';

// const AllUser = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [userData, setUserData] = useState({
//     username: "",
//     firstname: "",
//     lastname: "",
//     email: "",
//     password: "",
//     role: "",
//     userNotification: false,
//   });
//   const [uploadImage, setUploadImage] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [openDropdownId, setOpenDropdownId] = useState(null);
//   const [filteredData, setFilteredData] = useState(data);
//   const [showMessage, setShowMessage] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");
//   const rowsPerPage = 10;

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   const handleCloseMessageModal = () => {
//     setShowMessage(false);
//   };

//   useEffect(() => {
//     if (showMessage === true) {
//       const timeOut = setTimeout(() => {
//         setShowMessage(false);
//       }, 3000);

//       return () => clearTimeout(timeOut);
//     }
//   }, [showMessage]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   useEffect(() => {
//     fetchTableData();
//   }, []);

//   async function fetchTableData() {
//     setLoading(true);
//     setTimeout(async () => {
//       const URL = `${Url}/api/v1/users/get`;
//       const token = sessionStorage.getItem("authToken");

//       if (!token) {
//         const message = "No auth token found. Please log in.";
//         console.error(message);
//         setToastMessage(message);
//         setShowMessage(true);
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await fetch(URL, {
//           headers: {
//             Authorization: `${token}`,
//           },
//         });

//         if (response.ok) {
//           const users = await response.json();
//           const Users = users.data;
//           const reversedCategories = Users.reverse();

//           setData(reversedCategories);
//           setFilteredData(reversedCategories);
//           setToastMessage("Users Data have been fetched successfully!");
//           setShowMessage(true);
//         } else if (response.status === 401) {
//           const message = "Unauthorized: Invalid token.";
//           console.error(message);
//           setToastMessage(message);
//           setShowMessage(true);
//           handleLogout();
//         } else {
//           const message = `Error fetching data: ${response.statusText}`;
//           console.error(message);
//           setToastMessage(message);
//           setShowMessage(true);
//         }
//       } catch (error) {
//         const message = `Network error: ${error.message}`;
//         console.error(message);
//         setToastMessage(message);
//         setShowMessage(true);
//       } finally {
//         setLoading(false);
//       }
//     }, 2000);
//   }

//   const handleLogout = () => {
//     sessionStorage.removeItem("authToken");
//     window.location.href = "/";
//   };

//   const handleSearch = () => console.log("Search has been triggered");

//   const handleSelectAll = (isSelected) => {
//     if (isSelected) {
//       const allRowIds = data.map((row) => row._id);
//       setSelectedRows(allRowIds);
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   const handleRowSelect = (rowId) => {
//     setSelectedRows((prevSelected) => {
//       if (prevSelected.includes(rowId)) {
//         return prevSelected.filter((id) => id !== rowId);
//       } else {
//         return [...prevSelected, rowId];
//       }
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (type === "checkbox") {
//       setUserData((prevState) => ({
//         ...prevState,
//         [name]: checked,
//       }));
//     } else {
//       setUserData((prevState) => ({
//         ...prevState,
//         [name]: value,
//       }));
//     }
//   };

//   const handleuploadImage = (event) => {
//     const file = event.target.files[0];
//     const reader = new FileReader();
//     reader.onload = () => {
//       setUploadImage(reader.result);
//     };
//     if (file) {
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddUser = async () => {
//     const formData = new FormData();

//     formData.append("username", userData.username);
//     formData.append("firstname", userData.firstname);
//     formData.append("lastname", userData.lastname);
//     formData.append("email", userData.email);
//     formData.append("password", userData.password);
//     formData.append("role", userData.role);
//     formData.append("userNotification", userData.userNotification);

//     const uploadImageInput = document.getElementById("uploadImage");
//     if (uploadImageInput && uploadImageInput.files[0]) {
//       formData.append("image", uploadImageInput.files[0]);
//     }

//     try {
//       setLoading(true);
//       console.log("Form submission started with data:", userData);

//       const response = await axios.post(
//         `${Url}/api/v1/productCategory`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       console.log("Form submission successful:", response.data);
//       setToastMessage("User has been added successfully!");
//       setShowMessage(true);

//       setUserData({
//         username: "",
//         firstname: "",
//         lastname: "",
//         email: "",
//         password: "",
//         role: "",
//         userNotification: false,
//       });
//       setUploadImage(null);
//     } catch (error) {
//       let message = "An unexpected error occurred. Please try again.";
//       if (error.response) {
//         console.error("Error submitting form:", {
//           status: error.response.status,
//           data: error.response.data,
//           headers: error.response.headers,
//         });
//         message = error.response.data.message || message;
//       } else if (error.request) {
//         console.error("Error: No response received:", error.request);
//         message = "No response from server. Please check your connection.";
//       } else {
//         console.error("Error:", error.message);
//         message = error.message;
//       }
//       setToastMessage("Error: " + message);
//       setShowMessage(true);
//     } finally {
//       setLoading(false);
//       console.log("Form submission ended.");
//     }
//   };

//   const customStyles = {
//     headCells: {
//       style: {
//         height: "52px",
//         background: "transparent",
//         opacity: "1",
//         textAlign: "center",
//         justifyContent: "center",
//         border: "none",
//         color: "var(--text-color-1)",
//         fontFamily: "var(--font-family)",
//         fontWeight: "var(--font-weight-medium)",
//         fontSize: "var(--font-size-medium)",
//         overflow: "wrap",
//         textOverflow: "ellipsis",
//         whiteSpace: "normal",
//       },
//     },
//     cells: {
//       style: {
//         height: "66px",
//         justifyContent: "center",
//         textAlign: "center",
//         background: "transparent",
//         borderTop: "var(--standered-border)",
//         borderRight: "none",
//         color: "var(--text-color-1)",
//         fontFamily: "var(--font-family)",
//         fontWeight: "var(--font-weight-regular)",
//         fontSize: "var(--font-size-small)",
//         whiteSpace: "normal",
//         wordBreak: "break-word",
//         overflow: "wrap",
//         textOverflow: "ellipsis",
//       },
//     },
//   };

//   const toggleDropdown = (_id) => {
//     setOpenDropdownId((prevId) => (prevId === _id ? null : _id));
//   };

//   const handleAction = (action, row) => {
//     console.log(`Action: ${action} triggered for row:`, row);
//     switch (action) {
//       case "edit":
//         setOpenDropdownId(null);
//         break;
//       case "delete":
//         setOpenDropdownId(null);
//         break;
//       case "cancel":
//         setOpenDropdownId(null);
//         break;
//       case "view":
//         setOpenDropdownId(null);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (
//       !event.target.closest(".dropdown-menu") &&
//       !event.target.closest(".bar-icon")
//     ) {
//       setOpenDropdownId(null);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const columns = [
//     {
//       name: (
//         <input
//           type="checkbox"
//           style={{ margin: 0 }}
//           onChange={(e) => console.log("All selected:", e.target.checked)}
//         />
//       ),
//       cell: (row) => (loading ? <ShimmerLoader width="20px" height="20px" /> :
//         <input
//           type="checkbox"
//           style={{ margin: 0 }}
//           onChange={(e) => console.log("Selected:", row, e.target.checked)}
//         />
//       ),
//       ignoreRowClick: true,
//       allowOverflow: true,
//       button: true,
//       width: "35px",
//     },
//     {
//       name: "User Name",
//       cell: (row) =>
//         loading ? (
//           <ShimmerLoader width="120px" height="20px" borderRadius="20px" />
//         ) : (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "left",
//             }}
//           >
//             {row.image ? (
//               <img
//                 src={`${Url + row.image}`}
//                 alt={`${row.first_name} ${row.last_name}`}
//                 width="28px"
//                 height="28px"
//                 style={{
//                   borderRadius: "50%",
//                   marginRight: "15px",
//                   objectFit: "cover",
//                   color: 'var(--primary-color)',
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "#f0f0f0",
//                 }}
//               />
//             ) : (
//               <div
//                 style={{
//                   width: "35px",
//                   height: "35px",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "#f0f0f0",
//                 }}
//               >
//                 <PiImage size={28} color="var(--primary-color)" />
//               </div>
//             )}
//             <span style={{ color: 'black' }}>{row.username}</span>
//           </div>
//         ),
//         minWidth: "150px",
//         maxWidth: "220px",
//     },
//     {
//       name: "First Name",
//       selector: (row) => (loading ? <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" /> : row.first_name),
//       minWidth: "110px",
//       maxWidth: "140px",
//     },
//     {
//       name: "Last Name",
//       selector: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" borderRadius="15px" /> : row.last_name),
//       minWidth: "110px",
//       maxWidth: "140px",
//     },
//     {
//       name: "Email",
//       selector: (row) =>
//         loading ? (
//           <ShimmerLoader width="60px" height="22.5px" borderRadius="15px" />
//         ) : (
//           <Tooltip title={row.email || "No Email"}>
//             <span>{row.email || "No Email"}</span>
//           </Tooltip>
//         ),
//         minWidth: "65px",
//         maxWidth: "170px",
//     },
//     {
//       name: "Role",
//       selector: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" /> : row.role),
//       minWidth: "55px",
//       maxWidth: "90px",
//     },
//     {
//       name: "Action",
//       cell: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" /> :
//         <div style={{ position: "relative" }}>
//           <img
//             src={actionIcon}
//             alt="Action Icon"
//             width="40"
//             height="40"
//             style={{ cursor: "pointer", margin: 0, padding: 0 }}
//             className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
//               }`}
//             onClick={() => toggleDropdown(row._id)}
//           />
//           {openDropdownId === row._id && (
//             <div className={`dropdown-menu show animate-dropdown-left`}>
//               <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                 <li
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     padding: "5px 10px",
//                     border: "none",
//                   }}
//                   onClick={() => handleAction("view", row)}
//                 >
//                   <img
//                     src={eyeIcon}
//                     alt="View"
//                     width="15"
//                     height="15"
//                     style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
//                     className="icon-img"
//                   />
//                   View
//                 </li>
//                 <li
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     padding: "5px 10px",
//                     border: "none",
//                   }}
//                   onClick={() => handleAction("edit", row)}
//                 >
//                   <img
//                     src={editIcon}
//                     alt="Edit"
//                     width="15"
//                     height="15"
//                     style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
//                     className="icon-img"
//                   />
//                   Edit
//                 </li>
//                 <li
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     padding: "5px 10px",
//                     border: "none",
//                   }}
//                   onClick={() => handleAction("cancel", row)}
//                 >
//                   <img
//                     src={deleteIcon}
//                     alt="Delete"
//                     width="15"
//                     height="15"
//                     style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
//                     className="icon-img"
//                   />
//                   Cancel
//                 </li>
//                 <li
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     padding: "5px 10px",
//                     border: "none",
//                   }}
//                   onClick={() => handleAction("delete", row)}
//                 >
//                   <img
//                     src={deleteIcon}
//                     alt="Delete"
//                     width="15"
//                     height="15"
//                     style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
//                     className="icon-img"
//                   />
//                   Delete
//                 </li>
//               </ul>
//             </div>
//           )}
//         </div>
//       ),
//       minWidth: "55px",
//       maxWidth: "110px",
//     },
//   ];

//   const roleOptions = [
//     { value: "Customer", label: "Customer" },
//     { value: "Contributor", label: "Contributor" },
//     { value: "Store Manager", label: "Store Manager" },
//     { value: "Client Admin", label: "Client Admin" },
//     { value: "Product Editor", label: "Product Editor" },
//     { value: "Ads Manager", label: "Ads Manager" },
//     { value: "Analyst", label: "Analyst" },
//     { value: "Super Admin", label: "Super Admin" },
//   ];

//   const handleSelectedRole = (selectedValue) => {
//     setUserData((prevState) => ({
//       ...prevState,
//       role: selectedValue,
//     }));
//   };

//   const handlePasswordGen = () => {
//     const generatedPassword = Math.random().toString(36).slice(-8);
//     setUserData((prevState) => ({
//       ...prevState,
//       password: generatedPassword,
//     }));
//   };

//   const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

//   const displayedData = loading ? placeholderRows : paginatedData;

//   return (
//     <div className="AllUserPage">

//       <div className="UserSection-02">

//         <div className="Section2-Leftside-User">
//           <div className="Header">Add Users</div>
//           <div className="NewUser-Add">
//             <form
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 handleAddUser();
//               }}
//             >
//               <div className="formRow">
//                 <label htmlFor="username">
//                   User Name<span className="superscript">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="username"
//                   name="username"
//                   placeholder="Enter User Name..."
//                   value={userData.username}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>

//               <div className="formRow-1">
//                 <div className="firstName">
//                   <label htmlFor="firstname">
//                     First Name<span className="superscript">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="firstname"
//                     name="firstname"
//                     placeholder="Enter First Name..."
//                     value={userData.firstname}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>

//                 <div className="lastName">
//                   <label htmlFor="lastname">
//                     Last Name<span className="superscript">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="lastname"
//                     name="lastname"
//                     placeholder="Enter Last Name..."
//                     value={userData.lastname}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="formRow">
//                 <label htmlFor="email">
//                   Email<span className="superscript">*</span>
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   placeholder="Enter Email..."
//                   value={userData.email}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>

//               <div className="formRow">
//                 <label htmlFor="password">
//                   Password<span className="superscript">*</span>
//                 </label>
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   placeholder="Enter Password..."
//                   value={userData.password}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>

//               <div className="PasswordGenBtn">
//                 <CustomBtn
//                   label="Generate Password"
//                   className="GenPasswordBtn"
//                   onClick={handlePasswordGen}
//                   type="button"
//                 />
//               </div>

//               <div className="formRow custom-dropdown-wrapper-no-scroll">
//                 <label htmlFor="role">
//                   Select Role<span className="superscript">*</span>
//                 </label>
//                 <div className="custom-dropdown-wrapper">
//                   <CustomDropdown
//                     options={roleOptions}
//                     selectedOption={userData.role}
//                     handleOptionChange={handleSelectedRole}
//                     dropdownWidth='100%'
//                     dropdownMarginBottom="10px"
//                     backgroundColor="var(--third-layer-bg)"
//                     optionsWidth='100%'
//                     optionsBackgroundColor="var(--third-layer-bg)"
//                     dropdownSelectedStyle="7px"
//                   />
//                 </div>
//               </div>

//               <div
//                 className="form-group"
//                 style={{
//                   fontSize: "12px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-start",
//                   paddingBottom: "2px",
//                   marginTop: 10,
//                   marginBottom: 10,
//                 }}
//               >
//                 <input
//                   type="checkbox"
//                   name="userNotification"
//                   id="userNotification"
//                   checked={userData.userNotification}
//                   onChange={handleInputChange}
//                 />
//                 <label
//                   htmlFor="userNotification"
//                   style={{ fontSize: "12px", marginLeft: 10 }}
//                 >
//                   Send User Notification
//                 </label>
//               </div>

//               <div className="formRow">
//                 <label htmlFor="uploadImage">Upload Image</label>
//                 <div className="Image-upload">
//                   <label htmlFor="uploadImage" className="upload-label">
//                     <div className="UserImg-upload-button">
//                       <IoImageOutline size={45} color="#555" className="uploaded-image-User" />
//                       <span className="UserImg-upload-text">Click to Upload Image</span>
//                     </div>
//                   </label>
//                   <input
//                     type="file"
//                     id="uploadImage"
//                     name="uploadImage"
//                     className="upload-input"
//                     accept="image/*"
//                     onChange={handleuploadImage}
//                   />
//                 </div>
//                 {uploadImage && (
//                   <img
//                     src={uploadImage}
//                     alt="Upload Image"
//                     className="image-preview"
//                   />
//                 )}
//               </div>

//               <div className="SubmitBtn-User">
//                 <CustomBtn
//                   label="Add User"
//                   className="AddUserBtn"
//                   onClick={handleAddUser}
//                   type="button"
//                 />
//               </div>
//             </form>
//           </div>
//         </div>

//         <div className="Section2-Rightside-User">
//           <div>
//             <DataTable
//               columns={columns}
//               data={displayedData}
//               customStyles={customStyles}
//             />
//             <Pagination
//               activePageIndex={currentPage}
//               totalPages={totalPages}
//               onPrevPage={handlePrevPage}
//               onNextPage={handleNextPage}
//               onPageChange={handlePageChange}
//             />
//           </div>
//         </div>

//       </div>

//       <BottomToust
//         showMessage={showMessage}
//         message={toastMessage}
//         handleCloseMessageModal={() => handleCloseMessageModal()}
//       />

//     </div>
//   );
// };

// export default AllUser;

import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import "./Users.css";
import "../ECommerce/ECommerce.css";
import "../Page.css";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import editIcon from "../../Assets/Images/edit.png";
import deleteIcon from "../../Assets/Images/delete-black.png";
import eyeIcon from "../../Assets/Images/eye-black.png";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import { PiImage } from "react-icons/pi";
import { IoImageOutline } from "react-icons/io5";
import { security_key, Url } from "../../Services/Api";
import { Tooltip } from 'antd';
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { useAuth } from "../../Context/Auth/AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { CiWarning } from "react-icons/ci";

const AllUser = () => {

  const { auth } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [userToDelete, setUserToDelete] = useState({
    name: "",
    _id: ""
  });
  // const [showConfirm, setShowConfirm] = useState(false);

  const modalRef = useRef(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  const [viewOption, setViewOption] = useState(false);

  const [userData, setUserData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    role: "",
    selected_role: "",
    description: "",
    zelle_clients_access: false,
    image: null,
    created_by: {
      name: "",
      id: ""
    },
    userNotification: false,
    designation: "Store User"
  });

  const [uploadImage, setUploadImage] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [filteredData, setFilteredData] = useState(data);

  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);


  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  const rowsPerPage = 10;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  useEffect(() => {
    fetchTableData();
    fetchRoles();
  }, []);

  async function fetchTableData() {
    const RoleId = auth?.role?._id;
    setLoading(true);
    setTimeout(async () => {
      const URL = `${Url}/api/v1/users/users/by-role/${RoleId}`;
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      if (!token) {
        console.error("No auth token found. Please log in.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(URL, {
          headers: headers,
        });

        if (response.ok) {
          const users = await response.json();
          const Users = users.data;
          const reversedCategories = Users.reverse();

          setData(reversedCategories);
          setFilteredData(reversedCategories);
        } else if (response.status === 401) {
          console.error("Unauthorized: Invalid token.");
          handleLogout();
        } else {
          console.error("Error fetching data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }, 2000);
  }
  const [roles, setRoles] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  async function fetchRoles() {
    const RoleId = auth?.role?._id;
    setLoading(true);

    setTimeout(async () => {
      const URL = `${Url}/api/v1/roles/by-level/${RoleId}`;
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      if (!token) {
        console.error("No auth token found. Please log in.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(URL, {
          headers: headers,
        });

        if (response.ok) {
          const data = await response.json();
          const roles = data.data;

          // 🟢 Transform roles for dropdown (label + value as _id)
          const options = roles.map(role => ({
            label: role.roleName,
            value: role._id
          }));

          setRoles(roles);
          setRoleOptions(options); // 👈 set options for the dropdown
        } else if (response.status === 401) {
          console.error("Unauthorized: Invalid token.");
          handleLogout();
        } else {
          console.error("Error fetching data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }, 100);
  }


  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    window.location.href = "/";
  };

  const handleSearch = () => console.log("Search has been triggered");

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const allRowIds = data.map((row) => row._id);
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(rowId)) {
        return prevSelected.filter((id) => id !== rowId);
      } else {
        return [...prevSelected, rowId];
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setUserData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setUserData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };


  // const handleuploadImage = (event) => {
  //   const file = event.target.files[0];
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     setUploadImage(reader.result);
  //   };
  //   if (file) {
  //     reader.readAsDataURL(file);
  //   }
  // };


  const handleuploadImage = (event) => {
    const file = event.target.files[0];

    // 1MB in bytes
    const maxSizeInBytes = 1 * 1024 * 1024;

    if (file) {
      if (file.size > maxSizeInBytes) {
        setToastMessage("File size should be less than or equal to 1 MB.");
        setShowMessage(true)
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setUploadImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  const handleAddUser = async () => {
    setUploading(true);
    const formData = new FormData();

    // Correct the typo here
    const created_by_details = {
      name: sessionStorage.getItem("username"),  // Fixed the typo
      id: sessionStorage.getItem("_id")
    };

    // Append the necessary form data
    formData.append("username", userData.username);
    formData.append("first_name", userData.first_name);
    formData.append("last_name", userData.last_name);
    formData.append("email", userData.email);
    formData.append("password", userData.password);
    formData.append("role", userData.role);
    formData.append("designation", userData.selected_role);
    formData.append("userNotification", userData.userNotification);
    formData.append("description", userData.description);
    formData.append("zelle_clients_access", userData.zelle_clients_access ? 1 : 0);

    // Convert created_by_details to JSON string and append it
    formData.append("created_by", JSON.stringify(created_by_details));

    // Handle image upload
    const uploadImageInput = document.getElementById("uploadImage");
    if (uploadImageInput && uploadImageInput.files[0]) {
      formData.append("image", uploadImageInput.files[0]);
    }

    try {
      setUploading(true);
      console.log("Form submission started with data:", userData);
      const token = sessionStorage.getItem('authToken');
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await axios.post(
        `${Url}/api/v1/users/add`,
        formData,
        {
          headers: headers,
        }
      );

      console.log("Form submission successful:", response.data);
      setToastMessage("User Added Successfully.");
      setShowMessage(true)

      setUserData({
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        role: 0,
        selected_role: "",
        userNotification: false,
        description: ""
      });
      fetchTableData();
      setUploadImage(null);
    } catch (error) {
      if (error.response) {
        console.error("Error submitting form:", {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
        setUploading(false);
        alert(
          `Error: ${error.response.data.message ||
          "An error occurred. Please try again."
          }`
        );
      } else if (error.request) {
        setUploading(false);
        console.error("Error: No response received:", error.request);

      } else {
        setUploading(false);
        console.error("Error:", error.message);
      }
    } finally {
      setUploading(false);
      console.log("Form submission ended.");
    }
  };


  const customStyles = {
    headCells: {
      style: {
        height: "52px",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "var(--font-size-medium)",
        overflow: "wrap",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
      },
    },
    cells: {
      style: {
        height: "66px",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "var(--font-size-small)",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflow: "wrap",
        textOverflow: "ellipsis",
      },
    },
  };

  const toggleDropdown = (_id) => {
    setOpenDropdownId((prevId) => (prevId === _id ? null : _id));
  };


  const handleUpdateUserStatus = async (userId, status) => {
    setUploading(true);

    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await axios.put(
        `${Url}/api/v1/users/status`,
        {
          userId: userId,
          status: status // true = activate, false = deactivate
        },
        {
          headers: headers,
        }
      );

      console.log("Status update successful:", response.data);
      setToastMessage(`User ${status ? "Activated" : "Deactivated"} Successfully.`);
      setShowMessage(true);
      fetchTableData();

    } catch (error) {
      if (error.response) {
        console.error("Error updating status:", error.response);
        setToastMessage(`Error: ${error.response.data.message || "An error occurred. Please try again."}`);
        setShowMessage(true);
      } else if (error.request) {
        console.error("Error: No response received:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setUploading(false);
    }
  };


  const handleDeleteUser = async (userId) => {
    setIsLoading(true);
    console.log(userId, "here is userId");

    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await axios.delete(
        `${Url}/api/v1/users/delete`,
        {
          headers: headers,
          data: {
            userId: userId
          }
        }
      );

      console.log("Delete successful:", response.data);
      setToastMessage("User Deleted Successfully.");
      setShowConfirm(false);
      setUserToDelete({
        name: "",
        _id: ""
      });
      setShowMessage(true);

      fetchTableData();

    } catch (error) {
      if (error.response) {
        console.error("Error deleting user:", error.response);
        setToastMessage(`Error: ${error.response.data.message || "An error occurred. Please try again."}`);
        setShowMessage(true);
      } else if (error.request) {
        console.error("Error: No response received:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };



  const handleAction = (action, row) => {
    console.log(`Action: ${action} triggered for row:`, row);
    switch (action) {
      case "quick_view":
        setOpenDropdownId(null);
        console.log(row, "here");
        setViewOption(true);
        setUserData({
          username: row?.username,
          first_name: row?.first_name,
          last_name: row?.last_name,
          email: row?.email,
          password: row?.password,
          role: row?.role?._id,
          image: row?.image,
          description: row?.description

        })
        break;
      case "activate_deactivate":
        setOpenDropdownId(null);
        handleUpdateUserStatus(row?._id, !row?.status);
        break;
      case "delete":
        setOpenDropdownId(null);
        setUserToDelete({
          name: `${row?.first_name} ${row?.last_name}`,
          _id: row?._id
        });
        setShowConfirm(true);

        break;
      default:
        break;
    }
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".dropdown-menu") &&
      !event.target.closest(".bar-icon")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("All selected:", e.target.checked)}
        />
      ),
      cell: (row) => (loading ? <ShimmerLoader width="20px" height="20px" /> :
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("Selected:", row, e.target.checked)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "40px",
    },
    {
      name: "User Name",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="120px" height="20px" borderRadius="20px" />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "100%",
              marginLeft: "20px"
            }}
          >
            {row.image ? (
              <img
                src={`${Url + row.image}`}
                alt={`${row.first_name} ${row.last_name}`}
                width="28px"
                height="28px"
                style={{
                  borderRadius: "50%",
                  marginRight: "15px",
                  objectFit: "cover",
                  color: 'var(--primary-color)',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                }}
              />
            ) : (
              <div
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                }}
              >
                <PiImage size={28} color="var(--primary-color)" />
              </div>
            )}
            <span style={{ color: 'black' }}>{row.username}</span>
          </div>
        ),
      minWidth: "150px",
      maxWidth: "180px",
    },
    // {
    //   name: "First Name",
    //   selector: (row) => (loading ? <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" /> : row.first_name),
    //   minWidth: "110px",
    //   maxWidth: "140px",
    // },
    // {
    //   name: "Last Name",
    //   selector: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" borderRadius="15px" /> : row.last_name),
    //   minWidth: "110px",
    //   maxWidth: "140px",
    // },
    {
      name: "Full Name",
      selector: (row) => (loading ?
        <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" /> :
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "2px"
        }}>
          <span>{`${row.first_name} ${row.last_name}`}</span>
          <span>{`${row.email}`}</span>
        </div>
      ),
      minWidth: "110px",
      maxWidth: "200px",
    },
    // {
    //   name: "Email",
    //   selector: (row) =>
    //     loading ? (
    //       <ShimmerLoader width="60px" height="22.5px" borderRadius="15px" />
    //     ) : (
    //       <Tooltip title={row.email || "No Email"}>
    //         <span>{row.email || "No Email"}</span>
    //       </Tooltip>
    //     ),
    //   minWidth: "65px",
    //   maxWidth: "170px",
    // },
    {
      name: "Role",
      selector: (row) => (
        loading ? <ShimmerLoader width="60px" height="22.5px" /> :
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "2px"
          }}>

            <span>{`${row?.role?.roleName}`}</span>
            {
              row?.isDeleted ? <span
                style={{
                  background: "#ff4d503b",
                  color: "#FF4D4F",
                  padding: "4px 4px",
                  lineHeight: "8px",
                  borderRadius: "4px",
                  fontSize: "8px"
                }}
              >Deleted</span> : row?.status === false ? <span style={{
                background: "#6e6c6c5d",
                color: "#6e6c6cff",
                padding: "4px 4px",
                lineHeight: "8px",
                borderRadius: "4px",
                fontSize: "8px"
              }}>Deactivated</span> : <span></span>
            }
          </div>

      ),
      minWidth: "55px",
      maxWidth: "90px",
    },

    {
      name: "Action",
      cell: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" /> :
        <div style={{ position: "relative" }}>
          <img
            src={actionIcon}
            alt="Action Icon"
            width="40"
            height="40"
            style={{ cursor: "pointer", margin: 0, padding: 0 }}
            className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
              }`}
            onClick={() => toggleDropdown(row._id)}
          />
          {openDropdownId === row._id && (
            <div className={`dropdown-menu show animate-dropdown-left`}>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("quick_view", row)}
                >
                  <img
                    src={eyeIcon}
                    alt="View"
                    width="15"
                    height="15"
                    style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
                    className="icon-img"
                  />
                  Quick View
                </li>
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("activate_deactivate", row)}
                >
                  <img
                    src={editIcon}
                    alt="Edit"
                    width="15"
                    height="15"
                    style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
                    className="icon-img"
                  />
                  {row?.status ? "Deactive" : "Active"}
                </li>
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("delete", row)}
                >
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    width="15"
                    height="15"
                    style={{ marginRight: "12px", transition: "filter 0.05s ease", }}
                    className="icon-img"
                  />
                  Delete
                </li>
              </ul>
            </div>
          )}
        </div>
      ),
      minWidth: "55px",
      maxWidth: "110px",
    },
  ];

  // const roleOptions = [
  //   { value: "Customer", label: "Customer", id: 0 },
  //   { value: "Contributor", label: "Contributor", id: 1 },
  //   { value: "Store Manager", label: "Store Manager", id: 2 },
  //   { value: "Client Admin", label: "Client Admin", id: 3 },
  //   { value: "Product Editor", label: "Product Editor", id: 4 },
  //   { value: "Ads Manager", label: "Ads Manager", id: 5 },
  //   { value: "Analyst", label: "Analyst", id: 6 },
  //   { value: "Super Admin", label: "Super Admin", id: 7 },
  // ];

  const handleSelectedRole = (selected) => {

    setUserData(prev => ({
      ...prev,
      selected_role: selected,        // Store full object if needed
      selected_role_id: selected?.value, // Store just _id
      role: selected,
    }));

    console.log("Selected Role ID:", selected);
  };



  const handlePasswordGen = () => {
    const generatedPassword = Math.random().toString(36).slice(-8);
    setUserData((prevState) => ({
      ...prevState,
      password: generatedPassword,
    }));
  };

  const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

  const displayedData = loading ? placeholderRows : paginatedData;

  return (
    <div className="AllUserPage">

      <div className="UserSection-02">
        <div className="Section2-Leftside-User">
          <div className="Header">Add Users</div>
          <div className="NewUser-Add">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleAddUser();
              }}
            >
              <div className="formRow">
                <label htmlFor="username">
                  User Name<span className="superscript">*</span>
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter User Name..."
                  value={userData.username}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="formRow-1">
                <div className="firstName">
                  <label htmlFor="first_name">
                    First Name<span className="superscript">*</span>
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder="Enter First Name..."
                    value={userData.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="lastName">
                  <label htmlFor="last_name">
                    Last Name<span className="superscript">*</span>
                  </label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder="Enter Last Name..."
                    value={userData.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="formRow">
                <label htmlFor="email">
                  Email<span className="superscript">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter Email..."
                  value={userData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* <div className="formRow">
                <label htmlFor="password">
                  Password<span className="superscript">*</span>
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter Password..."
                  value={userData.password}
                  onChange={handleInputChange}
                  required
                />
              </div> */}


              {!viewOption && <div className="formRow" style={{ position: "relative" }}>
                <label htmlFor="password">
                  Password<span className="superscript">*</span>
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter Password..."
                  value={userData.password}
                  onChange={handleInputChange}
                  required
                  style={{ paddingRight: "35px" }} // space for icon
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "3%",
                    top: "66%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "15px"
                  }}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>}

              {!viewOption && <div className="PasswordGenBtn">
                <CustomBtn
                  label="Generate Password"
                  className="GenPasswordBtn"
                  onClick={handlePasswordGen}
                  type="button"
                />
              </div>}

              {!viewOption && <div className="formRow custom-dropdown-wrapper-no-scroll">
                <label htmlFor="role">
                  Select Role<span className="superscript">*</span>
                </label>
                <div className="custom-dropdown-wrapper">
                  <CustomDropdown
                    isMulti={false}
                    options={roleOptions} // ✅ Pass formatted options
                    selectedOption={userData.selected_role}
                    handleOptionChange={handleSelectedRole}
                    dropdownWidth="100%"
                    dropdownMarginBottom="10px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth="100%"
                    optionsBackgroundColor="var(--third-layer-bg)"
                    dropdownSelectedStyle="7px"
                  />


                </div>
              </div>}

              <div
                className="form-group"
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  paddingBottom: "2px",
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="checkbox"
                  name="zelle_clients_access"
                  id="zelle_clients_access"
                  checked={userData.zelle_clients_access}
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="zelle_clients_access"
                  style={{ fontSize: "12px", marginLeft: 10 }}
                >
                  Activate Zelle Clients
                </label>
              </div>

              <div
                className="form-group"
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  paddingBottom: "2px",
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="checkbox"
                  name="userNotification"
                  id="userNotification"
                  checked={userData.userNotification}
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="userNotification"
                  style={{ fontSize: "12px", marginLeft: 10 }}
                >
                  Send User Notification
                </label>
              </div>


              <div className="formRow">
                <label htmlFor="description">
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  placeholder="Enter Details of Employee"
                  value={userData.description}
                  onChange={handleInputChange}
                  required
                  rows={4} // You can adjust this number as needed
                  className="User-Textarea"
                  style={{}} // Optional: allow vertical resize
                />
              </div>

              {!viewOption && <div className="formRow image_uploader_user">
                <label htmlFor="uploadImage">Upload Image</label>
                {!uploadImage && <div className="Image-upload">
                  <label htmlFor="uploadImage" className="upload-label">
                    <div className="UserImg-upload-button">
                      <IoImageOutline size={45} color="#555" className="uploaded-image-User" />
                      <span className="UserImg-upload-text">Click to Upload Image</span>
                    </div>
                  </label>
                  <input
                    type="file"
                    id="uploadImage"
                    name="uploadImage"
                    className="upload-input"
                    accept="image/*"
                    onChange={handleuploadImage}
                  />
                </div>}
                {uploadImage && (
                  <img
                    src={uploadImage}
                    alt="Upload Image"
                    className="image-preview"
                  />
                )}
                {uploadImage && <button onClick={() => { setUploadImage(null) }} className="add_user_image_btn">
                  Change
                </button>}
              </div>}

              {
                viewOption && <img
                  src={Url + userData.image}
                  alt="Upload Image"
                  className="image-preview"
                />
              }

              <div className="SubmitBtn-User">
                {viewOption ? <CustomBtn
                  label="Add New User"
                  className="AddUserBtn"
                  onClick={() => {
                    setViewOption(false);
                    setUserData({
                      username: "",
                      first_name: "",
                      last_name: "",
                      email: "",
                      password: "",
                      role: "",
                      selected_role: "",
                      description: "",
                      zelle_clients_access: false,
                      image: null,
                      created_by: {
                        name: "",
                        id: ""
                      },
                      userNotification: false,
                      designation: "Store User"
                    })
                  }}
                  type="button"
                /> : <CustomBtn
                  label="Add User"
                  className="AddUserBtn"
                  onClick={handleAddUser}
                  type="button"
                />}
              </div>
            </form>
          </div>
        </div>
        <div className="Section2-Rightside-User">
          <div>
            <DataTable
              columns={columns}
              data={displayedData}
              customStyles={customStyles}
            />
            <Pagination
              activePageIndex={currentPage}
              totalPages={totalPages}
              onPrevPage={handlePrevPage}
              onNextPage={handleNextPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>


      {showConfirm && <div className="Delete-Confirmation-Modal">
        <div className="ModalContent" ref={modalRef}>
          <CiWarning className="warningIcon" />
          <div className="deleteHeading">Warning</div>
          <div className="deleteContent">
            Are you sure you want to delete Account of {userToDelete.name}? <br />
            This action cannot be undone.
          </div>
          <div className="separatorLine"></div>
          <div className="modalActions">
            <button
              className="NoteDelete-btn btnSecondary"
              onClick={() => {
                setShowConfirm(false);
                setUserToDelete({
                  name: "",
                  _id: ""
                });
              }}
            >
              Cancel
            </button>

            <div className="NoteSubmitBtn">
              <CustomBtn
                label={
                  isLoading ? (
                    <div className="btnLoader-Note"></div>
                  ) : (
                    "Confirm"
                  )
                }
                className={`NoteDeletebtn btnDanger ${isActive ? "active" : ""
                  }`}
                disabled={isLoading}
                onClick={() => {
                  console.log(userToDelete, "here uidd")
                  handleDeleteUser(userToDelete._id)
                }}
              />
            </div>
          </div>
        </div>
      </div>}

      {uploading && <div className="backdrop">
        <div className="loader-container">
          <MainLoader heading1={"Adding New User"} />
        </div>
      </div>}


      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />

    </div>

  );
};

export default AllUser;